import { render, staticRenderFns } from "./lawyer-recommend-card.vue?vue&type=template&id=1d1399b8&scoped=true&"
import script from "./lawyer-recommend-card.vue?vue&type=script&lang=js&"
export * from "./lawyer-recommend-card.vue?vue&type=script&lang=js&"
import style0 from "./lawyer-recommend-card.vue?vue&type=style&index=0&id=1d1399b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1399b8",
  null
  
)

export default component.exports